module.exports = {
      id: "downarrow-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#downarrow",
      toString: function () {
        return this.url;
      }
    }